import Axios, { InternalAxiosRequestConfig } from "axios";
import createAdministrateursDeBiensApi, {
  IApi as IAdministrateursDeBiensApi,
} from "./AdministrateursDeBiens";
import createBienApi, { IApi as IBienApi } from "./Bien";
import createDossierLocationApi, {
  IApi as IDossierLocationApi,
} from "./DossierLocation";
import createDossierParticulierApi, {
  IApi as IDossierParticulierApi,
} from "./DossierParticulier";
import createLocalisationApi, {
  IApi as ILocalisationApi,
} from "./Localisation";
import createPartenaireApi, { IApi as IPartenaireApi } from "./Partenaire";
import createUtilisateursApi, {
  IApi as IUtilisateursApi,
} from "./Utilisateurs";

import createDocumentsApi, { IApi as IDocumentsApi } from "./Documents";
import createMessagesApi, { IApi as IMessagesApi } from "./Message";
import { getToken } from "../Authentification/authentification";
/**
 * Création du client Axios
 */
export const createAxiosClient = (endpoint: string) => {
  const axiosClient = Axios.create({
    baseURL: endpoint,
    // tslint:disable: quotemark
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    // tslint:enable: quotemark
  });

  const requestHandler = (request: InternalAxiosRequestConfig) => {
    const token = getToken();
    if (token != undefined || token != null) {
      request.headers.Authorization = `Bearer ${token}` as string;
    }
    return request;
  };
  /**
   * Intercepteur Axios
   */
  axiosClient.interceptors.request.use(
    (request) => requestHandler(request),
    (error) => Promise.reject(error),
  );
  return axiosClient;
};

/**
 * Crée un nouveau client d'API
 * @param endpoint
 */
const create = (endpoint: string): IApi => {
  const axiosClient = createAxiosClient(endpoint);

  return {
    ...createAdministrateursDeBiensApi(endpoint, axiosClient),
    ...createDossierParticulierApi(endpoint, axiosClient),
    ...createLocalisationApi(endpoint, axiosClient),
    ...createBienApi(endpoint, axiosClient),
    ...createUtilisateursApi(endpoint, axiosClient),
    ...createDossierLocationApi(endpoint, axiosClient),
    ...createPartenaireApi(endpoint, axiosClient),
    ...createDocumentsApi(endpoint, axiosClient),
    ...createMessagesApi(endpoint, axiosClient),
  };
};

// Fusion des interfaces des API en une interface unique

export type IApi = IAdministrateursDeBiensApi &
  IUtilisateursApi &
  IDossierParticulierApi &
  IBienApi &
  ILocalisationApi &
  IDossierLocationApi &
  IPartenaireApi &
  IDocumentsApi &
  IMessagesApi;

export default { create };
